import React, { useState } from 'react'
import DraggableItem from '../../../global/DraggableItem';
import { isVideo } from '../../../utils';
import CustomVideo from '../../../global/ui/CustomVideo';

const ImageGridView = ({ filteredPhotos, onDownload, onInfo, onDelete, moveItem, onViewImg, folderId, onThumbnail, locationData }: any) => {

    const [openMenuId, setOpenMenuId] = useState<number | null>(null);

    const getName = (url: any) => {
        const fileName = new URL(url)?.pathname?.split("/")?.pop();
        return fileName
    }

    return (
        <div
            onClick={() => {
                setOpenMenuId(null)
            }}
            className="lg-grid"
        >
            {filteredPhotos?.map((photo: any, i: any) => (
                <DraggableItem
                    index={i}
                    key={photo?.id}
                    className="lv-card"
                    onClick={() => {
                        if (openMenuId) {
                            setOpenMenuId(null)
                            return
                        }
                        onViewImg(photo, i)
                    }}
                    moveItem={moveItem}
                    itemId={photo?.id}
                    renderType='image'
                    parentId={folderId}
                    data={photo}
                >
                    {isVideo(photo) ? (
                        <CustomVideo
                            className="lv-card__img"
                            src={photo?.image}
                            controls={false}
                        />
                    ) : (
                        <img
                            src={photo?.image}
                            alt={photo?.name}
                            className="lv-card__img"
                        />
                    )}
                    <div className="lv-card__overlay">
                        <div onClick={(e) => { e.stopPropagation() }} className="lv-card__info">
                            <span className="lv-card__city">{getName(photo?.image)}</span>
                        </div>
                        {locationData?.role != 'V' &&
                            <div className="lv-card__menu-wrap">
                                <button
                                    className="lv-card__menu-btn"
                                    onClick={e => {
                                        e.stopPropagation();
                                        setOpenMenuId(openMenuId === photo?.id ? null : photo?.id);
                                    }}
                                >
                                    <img src='/assets/images/dots-vertical-rounded.svg' alt='more' />
                                </button>
                                {openMenuId === photo?.id && (
                                    <div className="lv-card__menu-dropdown">
                                        <button
                                            onClick={() => {
                                                onInfo?.(photo)
                                                setOpenMenuId(null)
                                            }}
                                            className="lv-card__menu-item"
                                        >
                                            <img src='/assets/images/view-meta.svg' />
                                            Info
                                        </button>
                                        <button
                                            className="lv-card__menu-item"
                                            onClick={() => {
                                                onDelete(photo)
                                                setOpenMenuId(null)
                                            }}
                                        >
                                            <img src='/assets/images/Delete-icon-red.svg' />
                                            Delete
                                        </button>
                                        <button
                                            onClick={() => {
                                                onDownload?.(photo)
                                                setOpenMenuId(null)
                                            }}
                                            className="lv-card__menu-item"
                                        >
                                            <img src='/assets/images/download-blue.svg' />
                                            Download image
                                        </button>
                                        <button
                                            className="lg-info-menu__item"
                                            onClick={() => {
                                                onThumbnail?.(photo, 'image')
                                                setOpenMenuId(null)
                                            }}
                                        >
                                            <img width={20} height={20} src='/assets/images/badge-check.svg' />
                                            Use as thumbnail
                                        </button>
                                        <button
                                            className="lg-info-menu__item"
                                            onClick={() => {
                                                onThumbnail?.(photo, 'location')
                                                setOpenMenuId(null)
                                            }}
                                        >
                                            <img width={20} height={20} src='/assets/images/badge-check.svg' />
                                            Use as location thumbnail
                                        </button>
                                    </div>
                                )}
                            </div>
                        }
                    </div>
                </DraggableItem>
            ))}
        </div>
    )
}

export default ImageGridView